import { BfxBlotterInterventionContextMenuActionPayload } from "./BfxBlotterInterventionContextMenuActionPayload";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterInterventionContextMenuApprovalState {
  public actionRequests: BfxBlotterInterventionContextMenuActionPayload = {
    // this is slightly over cooked, but who can rule out additional actions
    approve: {
      approval: new Map<CubiqTS.SalesApprovalAction, string[]>(),
    },
    accept: {
      acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
    },
    reject: {
      approval: new Map<CubiqTS.SalesApprovalAction, string[]>(),
      acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
    },
  };

  public ineligibleTraderAccept: number = 0;
  public ineligibleTraderReject: number = 0;
  public ineligibleSalesApproval: number = 0;
  public ineligibleSalesReject: number = 0;

  public salesActions: number = 0;
  public traderActions: number = 0;

  constructor(public count: number = 0) {}

  public addTraderAcceptanceRequest(acceptanceType: CubiqTS.AcceptanceType, id: string) {
    if (!this.actionRequests.accept.acceptance.has(acceptanceType)) {
      this.actionRequests.accept.acceptance.set(acceptanceType, []);
    }
    this.actionRequests.accept.acceptance.get(acceptanceType).push(id);
  }

  public addTraderRejectRequest(acceptanceType: CubiqTS.AcceptanceType, id: string) {
    if (!this.actionRequests.reject.acceptance.has(acceptanceType)) {
      this.actionRequests.reject.acceptance.set(acceptanceType, []);
    }
    this.actionRequests.reject.acceptance.get(acceptanceType).push(id);
  }

  public addSalesApproveRequest(type: CubiqTS.SalesApprovalAction, id: string) {
    if (!this.actionRequests.approve.approval.has(type)) {
      this.actionRequests.approve.approval.set(type, []);
    }

    this.actionRequests.approve.approval.get(type).push(id);
  }

  public addSalesRejectRequest(type: CubiqTS.SalesApprovalAction, id: string) {
    if (!this.actionRequests.reject.approval.has(type)) {
      this.actionRequests.reject.approval.set(type, []);
    }

    this.actionRequests.reject.approval.get(type).push(id);
  }

  /* TRADER */
  public get isTraderAcceptIneligible(): boolean {
    return this.ineligibleTraderAccept > 0; // === this.count && this.count !== 0;
  }

  public get isTraderRejectIneligible(): boolean {
    return this.ineligibleTraderReject > 0; //=== this.count && this.count !== 0;
  }

  public get isTraderAction(): boolean {
    return this.traderActions > 0;
  }
  /* public get isAllTraderIneligible(): boolean {
        return this.ineligibleTraderReject > 0 && this.ineligibleTraderAccept > 0;
        //this.ineligibleTraderReject === this.count && this.ineligibleTraderAccept === this.count && this.count !== 0;
    }
 */
  /* SALES */
  public get isSalesApprovalIneligible(): boolean {
    return this.ineligibleSalesApproval > 0; //=== this.count && this.count !== 0;
  }

  public get isSalesRejectIneligible(): boolean {
    return this.ineligibleSalesReject > 0; //=== this.count && this.count !== 0;
  }

  public get isSalesAction(): boolean {
    return this.salesActions > 0;
  }
  /* public get isAllSalesIneligible(): boolean {
        return this.ineligibleSalesReject > 0  && this.ineligibleSalesApproval > 0;
        //this.ineligibleSalesReject === this.count && this.ineligibleSalesApproval === this.count && this.count !== 0;
    } */
}
